import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Input from "../../../../../components/textbox/Input";
import Utils from "../../../../../utils/Utils";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import {withTranslation} from "react-i18next";
import Select from "../../../../../components/select/Select"


class InfoNato extends Component {

    state = {
        infoNato: {
            pesoNato: "",
            pesoNonNoto: 0,
            etaGestazione: "",
            etaGestazioneNonNota: 0,
            etaDiagnosi: "",
            etaDiagnosiNonNota: 0,
            tipoEta: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.setEtaGestazioneNonNota = this.setEtaGestazioneNonNota.bind(this)
        this.setEtaDiagnosiNonNoto = this.setEtaDiagnosiNonNoto.bind(this)
        this.setPesoNonNoto = this.setPesoNonNoto.bind(this)
        this.setTipoEta = this.setTipoEta.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.validate = this.validate.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.datiSpecifici) {
            if (this.props.segnalazioneCopia.datiSpecifici.infoNato) {
                let infoNato = this.state.infoNato;
                let infoNatoCopia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici))
                infoNato.pesoNato = (infoNatoCopia.infoNato.pesoNato || infoNatoCopia.infoNato.pesoNato === 0) && infoNatoCopia.infoNato.pesoNato !== "9999" ? infoNatoCopia.infoNato.pesoNato : ""
                infoNato.pesoNonNoto = infoNatoCopia.infoNato.pesoNonNoto ? infoNatoCopia.infoNato.pesoNonNoto : 0
                infoNato.etaGestazione = (infoNatoCopia.infoNato.etaGestazione || infoNatoCopia.infoNato.etaGestazione === 0) && infoNatoCopia.infoNato.etaGestazione !== "99" ? infoNatoCopia.infoNato.etaGestazione : ""
                infoNato.etaGestazioneNonNota = infoNatoCopia.infoNato.etaGestazioneNonNota ? infoNatoCopia.infoNato.etaGestazioneNonNota : 0
                infoNato.etaDiagnosi = (infoNatoCopia.infoNato.etaDiagnosi || infoNatoCopia.infoNato.etaDiagnosi === 0) && infoNatoCopia.infoNato.etaDiagnosi !== "99" ? infoNatoCopia.infoNato.etaDiagnosi : ""
                infoNato.etaDiagnosiNonNota = infoNatoCopia.infoNato.etaDiagnosiNonNota ? infoNatoCopia.infoNato.etaDiagnosiNonNota : 0
                infoNato.tipoEta = infoNatoCopia.infoNato.tipoEta ? infoNatoCopia.infoNato.tipoEta : ""
                this.setState({infoNato: infoNato})
            }
        }
        this.controlloCorrettezza()
        this.props.setInfoNato(this.state.infoNato, this, undefined)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let objBackend = this.createJsonForBackend();
            this.props.setInfoNato(this.state.infoNato, this, objBackend)
        }

    }

    createJsonForBackend() {

        let infoNato = Object.assign({}, this.state.infoNato)
        let infoNatoObj = Utils.removeFieldFromObject(infoNato, "corretto");

        return infoNatoObj;
    }

    controlloCorrettezza() {
        let infoNato = this.state.infoNato
        infoNato.corretto = []

        if (this.state.infoNato.tipoEta !== "" && (!this.state.infoNato.etaDiagnosi && this.state.infoNato.etaDiagnosi !== 0)) {
            infoNato.corretto[0] = "Campo \"Età di diagnosi della malattia - Età\" mancante"
        } else infoNato.corretto[0] = ""

        this.setState({infoNato: infoNato})
    }

    validate() {

        if (this.state.infoNato.pesoNato !== "" && (parseInt(this.state.infoNato.pesoNato) < 0 || parseInt(this.state.infoNato.pesoNato) > 9998)) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_DA"]), 1
            )
        } else if (this.state.infoNato.etaGestazione !== "" && (parseInt(this.state.infoNato.etaGestazione) < 1 || parseInt(this.state.infoNato.etaGestazione) > 45)) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_DB"]), 1
            )
        } else if (this.state.infoNato.tipoEta === "1" && (parseInt(this.state.infoNato.etaDiagnosi) < 0 || parseInt(this.state.infoNato.etaDiagnosi) > 11)) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_DD"]), 1
            )
        } else if (this.state.infoNato.tipoEta === "2" && (parseInt(this.state.infoNato.etaDiagnosi) < 1 || parseInt(this.state.infoNato.etaDiagnosi) > 14)) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_DC"]), 1
            )

        }

        let stateInfoNato = this.state.infoNato;
        if (stateInfoNato.pesoNonNoto === 1)
            stateInfoNato.pesoNato = "9999";
        if (stateInfoNato.etaGestazioneNonNota === 1)
            stateInfoNato.etaGestazione = "99";
        if (stateInfoNato.etaDiagnosiNonNota === 1)
            stateInfoNato.etaDiagnosi = "99";
        let infoNato = Object.assign({}, stateInfoNato);
        let objFinal = Utils.removeFieldFromObject(infoNato, "corretto");
        this.props.setInfoNato(this.state.infoNato, this, objFinal);
    }

    riceviValore(field, event) {
        let infoNato = this.state.infoNato
        if (field === "pesoNato") {
            infoNato.pesoNato = event.target.value
            infoNato.pesoNonNoto = 0
        } else if (field === "etaGestazione") {
            infoNato.etaGestazione = event.target.value
            infoNato.etaGestazioneNonNota = 0
        } else if (field === "etaDiagnosi") {
            infoNato.etaDiagnosi = event.target.value
            infoNato.etaDiagnosiNonNota = 0
        }
        this.setState({infoNato: infoNato})
        this.controlloCorrettezza();
    }

    setPesoNonNoto() {
        let infoNato = this.state.infoNato
        if (infoNato.pesoNonNoto === 0) {
            infoNato.pesoNonNoto = 1
            infoNato.pesoNato = ""
        } else {
            infoNato.pesoNonNoto = 0
        }
        this.setState({infoNato: infoNato});
        this.controlloCorrettezza();
    }

    setEtaGestazioneNonNota() {
        let infoNato = this.state.infoNato
        if (infoNato.etaGestazioneNonNota === 0) {
            infoNato.etaGestazioneNonNota = 1
            infoNato.etaGestazione = ""
        } else {
            infoNato.etaGestazioneNonNota = 0
        }
        this.setState({infoNato: infoNato});
        this.controlloCorrettezza();
    }

    setEtaDiagnosiNonNoto() {
        let infoNato = this.state.infoNato
        if (infoNato.etaDiagnosiNonNota === 0) {
            infoNato.etaDiagnosiNonNota = 1

        } else {
            infoNato.etaDiagnosiNonNota = 0
        }
        infoNato.etaDiagnosi = ""
        infoNato.tipoEta = ""
        this.setState({infoNato: infoNato});
        this.controlloCorrettezza();
    }

    setTipoEta(event) {
        let infoNato = this.state.infoNato

        infoNato.tipoEta = event.target.value
        if (infoNato.tipoEta === "") {
            infoNato.etaDiagnosi = ""
        }

        if (infoNato.etaDiagnosiNonNota === 1) {
            infoNato.etaDiagnosiNonNota = 0
        }

        this.setState({infoNato: infoNato});
        this.controlloCorrettezza();
    }

    render() {

        const {t} = this.props
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("DatiSpecifici.InfoNato.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>

                    <div className={"row"}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("DatiSpecifici.InfoNato.peso")}</p>
                            <div className="row">
                                <div className={`col-lg-8 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello7' : ''}`}>
                                    <Input id={"pesoNato"} field={"pesoNato"}
                                           type={"number"}
                                           min="0"
                                           max="9999"
                                           errorMessage={"Peso non valido"}
                                           value={this.state.infoNato.pesoNato}
                                           disabled={this.state.infoNato.pesoNonNoto === 1}
                                           placeholder={"Peso"}
                                           onChange={this.riceviValore}>
                                    </Input>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello6' : ''}`}>
                                    <RadioButton id={"pesoNonNoto"} name={"pesoNonNoto"} label={"Non Noto"}
                                                 field={"Non Noto"}
                                                 onClick={this.setPesoNonNoto}
                                                 smallLabel={true}
                                                 value={this.state.infoNato.pesoNonNoto}
                                                 checked={this.state.infoNato.pesoNonNoto === 1}>
                                    </RadioButton>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("DatiSpecifici.InfoNato.etaGestazionale")}</p>
                            <div className="row">
                                <div className={`col-lg-8 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello5' : ''}`}>
                                    <Input id={"etaGestazione"} field={"etaGestazione"}
                                           errorMessage={"età non valida"}
                                           type={"number"}
                                           min="1"
                                           max="45"
                                           value={this.state.infoNato.etaGestazione}
                                           disabled={this.state.infoNato.etaGestazioneNonNota === 1}
                                           placeholder={"età"}
                                           onChange={this.riceviValore}>

                                    </Input>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                                    <RadioButton id={"etaGestazioneNonNota"} name={"etaGestazioneNonNota"}
                                                 label={"Non Noto"}
                                                 field={"etaGestazioneNonNota"}
                                                 onClick={this.setEtaGestazioneNonNota}
                                                 smallLabel={true}
                                                 value={this.state.infoNato.etaGestazioneNonNota}
                                                 checked={this.state.infoNato.etaGestazioneNonNota === 1}>
                                    </RadioButton>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("DatiSpecifici.InfoNato.etaDiagnosi")}</p>
                            <div className="row">
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    <Select
                                        value={this.state.infoNato.tipoEta}
                                        onChange={this.setTipoEta}
                                        functionMap={Utils.mapToArray(OggettiUtili.MesiOAnni).map((oggetto) => {
                                            return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}>
                                    </Select>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"etaDiagnosi"} field={"etaDiagnosi"}
                                           errorMessage={"Età non valida"}
                                           value={this.state.infoNato.etaDiagnosi}
                                           type={"number"}
                                           min={this.state.infoNato.tipoEta === "1" ? "0" : "1"}
                                           max={this.state.infoNato.tipoEta === "1" ? "11" : "14"}
                                           placeholder={"Età"}
                                           disabled={this.state.infoNato.tipoEta === ""}
                                           onChange={this.riceviValore}>
                                    </Input>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <RadioButton id={"etaDiagnosiNonNota"} name={"etaDiagnosiNonNota"}
                                                 label={"Non Noto"}
                                                 field={"etaDiagnosiNonNota"}
                                                 onClick={this.setEtaDiagnosiNonNoto}
                                                 smallLabel={true}
                                                 value={this.state.infoNato.etaDiagnosiNonNota}
                                                 checked={this.state.infoNato.etaDiagnosiNonNota === 1}>
                                    </RadioButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(InfoNato);
